import { Component, OnInit } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { HorizonsTeam } from 'src/app/core/models/horizons-team.model';
import { Pagination, PaginationRequest } from 'src/app/core/models/pagination.model';
import { ConfigService } from 'src/app/core/services/config.service';
import { UserService } from 'src/app/core/services/user.service';
import * as utils from 'src/app/shared/helpers/utils';

@Component({
  selector: 'hbo-horizons-team-list',
  templateUrl: './horizons-team-list.component.html',
  styleUrls: ['./horizons-team-list.component.scss']
})
export class HorizonsTeamListComponent implements OnInit {

  horizonsTeams$ = new Observable<Pagination<HorizonsTeam>>;
  horizonsTeamsCollection$: HorizonsTeam[] = [];

  constructor(
    private userService: UserService,
    private configSvc: ConfigService
  ) {
    this.getHorizonsTeams();
  }

  ngOnInit() {
    this.searchHorizonsTeams();
  }

  searchHorizonsTeams(pagination?: PaginationRequest, reload = false) {
    this.horizonsTeams$ = this.userService.getHorizonsTeams(pagination ?? { sort:'id', order: 'desc' }, true).pipe(tap(result => this.horizonsTeamsCollection$ = result.data));

  }

  getHorizonsTeams = () => {
    if (!this.configSvc.currentConfigValue.horizonsTeams) {
      this.userService.getHorizonsTeams({ perPage: -1, order: 'desc' }).subscribe(horizonsTeams => {
        this.configSvc.setConfigParamsValue('horizonsTeams', horizonsTeams.data);
      });
    }
  }

  callback = (e: any) => {
    switch (e.action) {
      case 'updated':
        const propsToRemove = [];
        this.horizonsTeamsCollection$.map((ht: HorizonsTeam) => {
          if (ht.id === e.result.id) { utils.deepMerge(ht, e.result) };
        })
        break;
      case 'deleted':
        this.searchHorizonsTeams();
        break;
      default:
        break;
    }
  }
}
